import { COLORS } from "shared/consts";
import styled from "styled-components";

export const HiveBodyWrapper = styled.div`
    overflow-y: auto;
    overflow-x: auto;
    width: calc(100% + 32px);
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 16px;
    margin: 0 0 0 -16px;
    background: ${COLORS.BG.PAGE_FILLED};
`